export default function validateLoadField(loads: Record<string, number>): boolean {
  if (Object.keys(loads).length === 0) {
    return true
  }

  return Object.values(loads).every((load: number) => !isNaN(load) && load > 0)
}
